import { NeoProvider } from "@kensho/neo";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";

import { NotFoundPage } from "./not-found-page";
import { UnknownErrorPage } from "./unknown-error-page";

export function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <NeoProvider navigate={navigate}>
      {isRouteErrorResponse(error) && error.status === 404 ? (
        <NotFoundPage />
      ) : (
        <UnknownErrorPage />
      )}
    </NeoProvider>
  );
}
